import { useCallback, useEffect, useState } from "react";
import { residentApi, errMsg } from "../lib/api";
import { useResident } from "../context/ResidentAuth";
import { BalanceCard } from "../components/resident/BalanceCard";
import { StatementTable } from "../components/resident/StatementTable";
import { PayDialog } from "../components/resident/PayDialog";
import { RecentPayments } from "../components/resident/RecentPayments";

const thisYear = new Date().getFullYear();
const YEARS = Array.from({ length: thisYear - 2021 + 1 }, (_, i) => thisYear - i);

export default function PaymentsPage() {
  const { resident } = useResident();
  const [year, setYear] = useState(thisYear - 1);
  const [st, setSt] = useState(null);
  const [bank, setBank] = useState(null);
  const [err, setErr] = useState("");
  const [payOpen, setPayOpen] = useState(false);

  const load = useCallback(() => {
    residentApi.get("/resident/statement", { params: { start: `${year}-01-01` } }).then((r) => setSt(r.data)).catch((e) => setErr(errMsg(e)));
  }, [year]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    residentApi.get("/resident/bank-info").then((r) => setBank(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
      <p className="eyebrow text-[#E07A5F]">Sakin Paneli</p>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1B4332] mt-2" data-testid="payments-title">
        Hoş geldiniz, {resident?.name}
      </h1>
      <p className="text-slate-500 mt-1 text-sm">{resident?.villa_no} · {resident?.type}</p>
      {err && <p className="mt-6 text-red-600" data-testid="payments-error">{err}</p>}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8 [&>*]:min-w-0">
        <div className="lg:col-span-2 min-w-0">
          <BalanceCard balance={st?.totals.balance} loading={!st} period={st?.active_period} onPay={() => setPayOpen(true)} />
        </div>
        <RecentPayments items={st?.recent_payments || []} />
      </div>
      <StatementTable st={st} year={year} years={YEARS} onYear={setYear} />
      {st && bank && (
        <PayDialog open={payOpen} onOpenChange={setPayOpen} balance={st.totals.balance} bank={bank} resident={resident} />
      )}
    </div>
  );
}
